























































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextfield, SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { SwFileUpload } from '@libs-uuif/shared/sw-file-upload';
import { SwForm } from '@libs-uuif/shared/sw-form';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import { currentUserKey } from '@/shared/msw-constants';
import { envCongif } from '@/shared/env.config';
import axios from 'axios';
const cssPrefix = 'support-cases-file-upload';
@Component({
  components: {
    ...UUIFComponents,
    SwTextfield,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwTextarea,
    SwFileUpload,
    SwForm,
  },
})
export default class SupportFileUpload extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  fileUploadModal: boolean;
  logFileDesc: string = '';
  logFileNote: string = '';
  file:File[] = [];
  showFileError: boolean = false;
  errMsg: string = '';
  showCancelBtn: boolean = false;
  cancelUpload: boolean = false;
  cancelRequest: any;
  selectedFile: any;
  progress: any;
  options: any;
  document: any = {};
  awsUploadUrl: string = 'https://gddfubayy2x4xlj5r5xql3k3b40emdrj.lambda-url.us-west-2.on.aws/';
  uploadClicked: boolean = false;
  showLabel2: boolean = false;
  error: any;
  @Prop()
  caseDetails: any;
  @Prop()
  origin: string;
  detailedFile: any = {};

  get getModalWidth() {
    const width: string = '35%';
    return width;
  }
  // mounted() {
  //   if (this.origin === 'fromManageCase') {
  //     this.$store.dispatch('getAppVersion')
  //     .then((result: any) => {
  //       this.awsUploadUrl = result.content.supportattachurl;
  //       console.warn(this.awsUploadUrl);
  //     });
  //   }
  // }
  closeDialog() {
    this.$emit('close-dialog');
  }
  onAddingNote(value: any) {
    if (value) {
      this.logFileNote = value.length > 1500 ? value.slice(0, 1500) : value;
    }
  }
  selectFileFromManageCase() {
    console.warn('selected file', this.document);
  }
  selectFileFromCreateCase() {
    if (this.document) {
      const fileCompleteDetails: any = {
        file: this.document.files[0].file,
        note: this.logFileNote,
        desc: this.logFileDesc,
      };
      this.detailedFile = fileCompleteDetails;
    }
  }
  uploadFileSubmit() {
    // if (Object.keys(this.detailedFile).length === 0) {
    console.warn(this.document.files[0].name.length, this.document.files[0].name);
    this.showFileError = false;
    if (Object.keys(this.document).length === 0) {
      this.showFileError = true;
      this.errMsg = (this.$t('supportFileUpload.errMsg1')
      .toString());
    } else {
      this.showFileError = false;
      const fileName = this.document.files[0].file.name;
      if (fileName.split('.')
        .pop() === 'exe') {
        this.showFileError = true;
        this.errMsg = (this.$t('supportFileUpload.errMsg2')
        .toString());
      } else if (this.document.files[0].name.length > 255) {
        this.showFileError = true;
        this.errMsg = (this.$t('supportFileUpload.errMsg3')
        .toString());
      } else if (parseFloat((this.document.files[0].file.size / (1024 * 1024 * 1024)).toFixed(2)) > 5) {
        this.showFileError = true;
        this.errMsg = (this.$t('supportFileUpload.errMsg4')
        .toString());
      } else if (fileName.includes('#')) {
        this.showFileError = true;
        this.errMsg = (this.$t('supportFileUpload.errMsg5')
        .toString());
      }
    }
    if (!this.showFileError) {
      if (this.origin === 'fromManageCase') {
        const currentUserToken: any = JSON.parse(localStorage.getItem(currentUserKey) as any).token;
        const payload = {
          authToken: currentUserToken,
          caseNo: this.caseDetails.id,
          Mode: 'PUT',
          env: envCongif.env,
        };
        console.warn(this.document.options.uploadUrl);
        try {
          this.uploadClicked = true;
          this.document.files[0].progress = 0;
          axios.post(this.awsUploadUrl, payload, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(async (postRes: any) => {
            if (postRes) {
              const respString: any = postRes.data.split(',');
              const axiosSource = axios.CancelToken.source();
              this.cancelRequest = { cancel: axiosSource.cancel };
              const config = {
                onUploadProgress: (progressEvent: { loaded: number; total: number; }) => {
                  const completedPercent = (progressEvent.loaded / progressEvent.total) * 100;
                  this.document.files[0].progress = completedPercent;
                  this.showCancelBtn = true;
                },
                cancelToken: axiosSource.token,
                headers: {
                  'Content-Type': '',
                },
              };
              axios.put(respString[1].substring(10), this.document.files[0].file, config)
              .then((putRes: any) => {
                this.showCancelBtn = false;
                this.showLabel2 = true;
                if (putRes.status === 200) {
                  // const caseNumber = this.caseDetails.caseno.toString();
                  // const downloadUrl = `${this.options.uploadUrl}/?caseno=${caseNumber}&sid=2222&filename=${this.selectedFile.name}`;
                  const payload = {
                    caseNumber: this.caseDetails.id,
                    caseId: this.caseDetails.caseno,
                    descriptiveName: this.logFileDesc,
                    addNote: this.logFileNote,
                    fileName: respString[0].substring(9),
                    origFileName: this.document.files[0].file.name,
                  };
                  try {
                    this.$store.dispatch('MswSupportCasesModule/uploadSupportAttachment', payload)
                    .then((response: any) => {
                      if (response.msgCode === 'MSWAPP:SUCCESS') {
                        this.$store.commit('stopLoading');
                        // if (this.origin === 'fromCreateCase') {
                        //   this.$emit('get-files', this.detailedFile);
                        // }
                        this.$emit('close-dialog', this.origin);
                      } else {
                        this.$store.commit('stopLoading');
                        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
                      }
                    });
                  } catch (err) {
                    this.$store.commit('stopLoading');
                    this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong.' });
                    console.error(err);
                  }
                }
              })
              .catch((e: any) => {
                console.warn(e);
                !this.cancelUpload ? this.document.files[0].progress = false : '';
                this.uploadClicked = false;
                !this.cancelUpload && this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong. Please try again' });
              });
            }
          });
        } catch (e) {
          this.uploadClicked = false;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong. Please try after sometime' });
          this.document.files[0].progress = false;
        }
      } else {
        const obj = {
          doc: this.document,
          note: this.logFileNote,
          desc: this.logFileDesc,
        };
        this.$emit('get-files', obj);
        this.$emit('close-dialog');
      }
    }
  }
  cancelUploadMethod() {
    if (this.cancelRequest) {
      this.cancelUpload = true;
      this.cancelRequest.cancel();
      this.showCancelBtn = false;
      this.document = {};
    }
  }
}
